import { Dispatch } from "react"
import { Action, CheckoutActionKind, State } from "../types/checkoutTypes"

export const incrementCartItem = (
  cartItemId: string,
  state: State,
  dispatch: Dispatch<Action>
) => {
  // Update global state
  dispatch({
    type: CheckoutActionKind.INCREMENT_CART_ITEM,
    payload: { cartItemId },
  })
}
